'use client';

import {
  DialogDrawer,
  DialogDrawerContent,
} from '@/components/ui/mobile-responsive-dialog-drawer';
import { trackPracticeInviteClick } from '@/models/analytics/features/trackPracticeTrialInviteAnalytics';
import { isAppleCompliantBuild } from '@/utils/appConfiguration';
import {
  PracticeInviteTeamModalLoading,
  practiceInviteTeamModalOpenAtom,
} from '@heidi/commerce';
import {
  PRACTICE_INVITE_ACTION,
  TRIALS_AND_UPGRADES_SCREEN,
} from '@heidi/commerce/contracts';
import { useAtom } from 'jotai';
import dynamic from 'next/dynamic';
import { useCallback, useState } from 'react';

const PracticeInviteTeamModalContent = dynamic(
  () =>
    import('./practice-invite-team-modal-content').then(
      (mod) => mod.PracticeInviteTeamModalContent
    ),
  {
    loading: () => <PracticeInviteTeamModalLoading />,
    ssr: false,
  }
);

export function PracticeInviteTeamModal() {
  const [isOpen, setIsOpen] = useAtom(practiceInviteTeamModalOpenAtom);
  const [isDialogVisible, setIsDialogVisible] = useState(isOpen);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  const handleOpenChange = useCallback(
    (open: boolean) => {
      if (!open) {
        trackPracticeInviteClick({
          screen_name: TRIALS_AND_UPGRADES_SCREEN.practiceInviteTeam,
          action: PRACTICE_INVITE_ACTION.close,
          label: 'Close',
        });
        handleClose();
      }
    },
    [handleClose]
  );

  if (isAppleCompliantBuild()) {
    return null;
  }

  return (
    <DialogDrawer
      open={isOpen}
      onOpenChange={handleOpenChange}
      onOpenChangeComplete={setIsDialogVisible}
    >
      <DialogDrawerContent
        className="mb-auto flex h-fit max-w-[470px] flex-col items-center gap-6 border-0 p-4 sm:p-8"
        overlayClassName="backdrop-blur-[3px]"
        dismissible
        hideCloseIcon
      >
        {isOpen && isDialogVisible ? (
          <PracticeInviteTeamModalContent onClose={handleClose} />
        ) : (
          <PracticeInviteTeamModalLoading />
        )}
      </DialogDrawerContent>
    </DialogDrawer>
  );
}
